import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import { Center } from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/organization/profile/contact/edit";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import Input from "../../../../../../components/Form/Input";
import organizationActions from "../../../../../../store/actions/organization";
import { hideModal } from "../../../../../../store/actions/modal";

const Component = ({
  selectedOrganization,
  updateOrganizationStates,
  current,
  organizations,
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const dispatch = useDispatch();
  const organizationFounded = organizations?.find(
    (organization) => organization._id === current.id
  );
  const onSubmit = ({ values, actions }) => {
    dispatch(organizationActions.update({ _id: current.id, ...values }));
    setFormActions(actions);
  };

  useEffect(() => {
    if (updateOrganizationStates.success) {
      toast("👌🏼 Organizacion editada", {
        containerId: "submit",
        type: "success",
        toastId: "submitsucceful",
      });

      setTimeout(() => {
        dispatch(organizationActions.resetUpdate());
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }

    if (updateOrganizationStates.error) {
      toast(`😱 ${updateOrganizationStates.error}`, {
        containerId: "submit",
        type: "error",
        toastId: "submiterror",
      });

      setTimeout(() => {
        dispatch(organizationActions.resetUpdate());
      }, 1000);
    }
  }, [updateOrganizationStates]);

  return (
    <Modal name="edit-organization-profile" title="Datos de la Organización">
      <Formik
        initialValues={{
          ...initialValues(
            !!organizationFounded && {
              name: organizationFounded.name,
              description: organizationFounded.description || "",
            }
          ),
        }}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={formSubmmited}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="edit-organization-profile-form"
            >
              <Grid.Row>
                <Grid.Col>
                  <Input
                    name={"name"}
                    error={errors["name"]}
                    touched={touched["name"]}
                    value={values["name"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{ label: "Nombre", skin: "gray" }}
                  />
                  <Input
                    name={"description"}
                    error={errors["description"]}
                    touched={touched["description"]}
                    value={values["description"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{
                      label: "A que se dedica la Organización",
                      skin: "gray",
                    }}
                  />
                </Grid.Col>
              </Grid.Row>

              <Grid.Row>
                <Grid.Col>
                  <Center gap={"70px"}>
                    <Button
                      onClick={resetForm}
                      type="button"
                      options={{
                        type: "outline",
                        skin: "gray",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                      style={{ marginLeft: "10px" }}
                    >
                      Cancelar
                    </Button>

                    <Submit
                      isSubmmiting={updateOrganizationStates.loading}
                      form="edit-organization-profile-form"
                      color="Primary"
                      options={{
                        type: "filled",
                        skin: "primary",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                    >
                      Confirmar
                    </Submit>
                  </Center>
                </Grid.Col>
              </Grid.Row>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const states = ({ organizationStore, currentStore }) => {
  const { data: selectedOrganization } = organizationStore.selected;
  const { states: updateOrganizationStates } = organizationStore.update;
  const { data: current } = currentStore;
  const { data: organizations } = organizationStore.all;
  return {
    selectedOrganization,
    updateOrganizationStates,
    current,
    organizations,
  };
};

export default connect(states)(Component);
